export var altNamesTranslations = {
    AgencyWorker: { id: "ui-br-publishers.role.agencyWorker" },
    PublisherAdmin: { id: "ui-br-publishers.role.publisherAdmin" },
    PublisherGuarantor: { id: "ui-br-publishers.role.publisherGuarantor" },
    Superuser: {
        id: "ui-br-publishers.role.superuser",
    },
};
export var getRolesTranslations = function (intl, key) {
    var translation = altNamesTranslations[key];
    if (!translation)
        return key;
    return intl.formatMessage(translation);
};
